(ns practitest.frontend.common-entities.metadata
  (:require
    [practitest.frontend.common.i18n :refer [get-translation]]
    [practitest.frontend.components.icons :as icons]))

(def entities-metadata
  {:requirement {:urls {:fetch-list "requirements#list2"
                        :new "requirements#new"
                        :entity "requirements#entity"
                        :index "requirements#index"
                        :create "requirements#create"
                        :update "requirements#update"
                        :edit "requirements#edit"
                        :delete "requirements#destroy"
                        :print "requirements#print"
                        :unlink_from_external "requirement_integrations#unlink_from_external"
                        :jump-to "requirements#jump_to"
                        :batch-edit "requirements#batch_edit"
                        :comments "requirements#comments"
                        :attachments "requirements#attachments"
                        :link-entities "requirements#link_entities"
                        :unlink-entity "requirements#unlink_entity"}
                 :routes {:index :practitest.frontend.requirements.index/index
                          :edit :practitest.frontend.forms3.requirements/edit
                          :entity-key :requirement-id}
                 :singular-name {:key "requirement.singular" :default "Requirement"}
                 :plural-name {:key "requirement.plural" :default "Requirements"}
                 :page-title {:key "requirement.grid.title" :default "Requirements"}
                 :linked-label "Requirements"
                 :db-entity "Requirement"
                 :db-table-name "requirements"
                 :plural-key :requirements
                 :module "Requirement"
                 :edit-permissions "requirements_editor"
                 :delete-permissions "requirements_admin"
                 :new-ui-form? false
                 :form-id :requirement-form
                 :linked-ids-key :linked_requirement_ids
                 :init-traceability {:issues [], :tests []}
                 :table-id "requirements-index"
                 :columns-id :requirement-columns
                 :default-columns [{:type :external_id_or_display_id
                                    :field :display_id
                                    :default-width 80
                                    :default-show? true
                                    :autofilter? true
                                    :header "ID"}]
                 :has-followers? true}
   :test {:urls {:fetch-list "qtest_designs#list2"
                 :entity "qtest_designs#entity"
                 :new "qtest_designs#new"
                 :index "qtest_designs#index"
                 :create "qtest_designs#create"
                 :update "qtest_designs#update"
                 :edit "qtest_designs#edit"
                 :delete "qtest_designs#destroy"
                 :print "qtest_designs#print"
                 :convert-test-type "qtest_designs#convert_test_type"
                 :clone "qtest_designs#clone_entity"
                 :jump-to "tests#jump_to"
                 :batch-edit "tests#batch_edit"
                 :comments "qtest_designs#comments"
                 :attachments "qtest_designs#attachments"
                 :stage-link-entities "qtest_designs#stage_link_entities"
                 :link-entities "qtest_designs#link_entities"
                 :unlink-entity "qtest_designs#unlink_entity"}
          :routes {:index :practitest.frontend.tests.index/index
                   :new :practitest.frontend.tests.test-form/new
                   :edit :practitest.frontend.tests.test-form/edit
                   :entity-key :test-id}
          :singular-name {:key "test.singular" :default "Test"}
          :plural-name {:key "test.plural" :default "Tests"}
          :page-title {:key "test.grid.title" :default "Tests"}
          :linked-label "Tests"
          :db-entity "QtestDesign"
          :db-table-name "qtest_designs"
          :plural-key :tests
          :module "Test"
          :edit-permissions "tests_editor"
          :delete-permissions "tests_admin"
          :new-ui-form? false
          :form-id :test-main
          :linked-ids-key :test_ids
          :init-traceability {:instances [] :issues [] :requirements [] :called_by_ctts []}
          :table-id "tests-index"
          :columns-id :test-columns
          :has-similar-items? true
          :default-columns [{:type :display_id
                             :field :display_id
                             :default-width 80
                             :default-show? true
                             :autofilter? true
                             :header "ID"}
                            {:type          :has_issue_indicator
                             :field         :has_issue_indicator
                             :autofilter?   false
                             :default-width 80
                             :header        [icons/mux-issue]
                             :sortable?     true}]
          :has-followers? true}
   :testset {:urls {:fetch-list "suites#list2"
                    :new :practitest.frontend.testset2/new
                    :entity "suites#entity"
                    :index "suites#index"
                    :create "suites#create"
                    :update "suites#update"
                    :edit "suites#edit"
                    :delete "suites#destroy"
                    :print "suites#print"
                    :jump-to "suites#jump_to"
                    :batch-edit "suites#batch_edit"
                    :comments "suites#comments"
                    :attachments "suites#attachments"}
             :routes {:index :practitest.frontend.testset2.index/index
                      :edit :practitest.frontend.testset2/edit
                      :entity-key :testset-id}
             :singular-name {:key "testset.singular" :default "Test Set"}
             :plural-name {:key "testset.plural" :default "Test Sets"}
             :plural-key :sets
             :page-title {:key "testset.grid.title" :default "Test Sets & Runs"}
             :linked-label "Test Sets"
             :db-entity "Suite"
             :db-table-name "suites"
             :module "TestSet"
             :edit-permissions "sets_editor"
             :delete-permissions "sets_admin"
             :new-ui-form? true
             :table-id "testset-index"
             :form-id :testset
             :columns-id :testset-columns
             :default-columns [{:type :display_id
                                :field :display_id
                                :default-width 80
                                :default-show? true
                                :autofilter? true
                                :header "ID"}]
             :has-followers? false}
   :milestone {:urls {:entity "milestones#entity"
                      :index "milestones#index"
                      :create "milestones#create"
                      :update "milestones#update"
                      :edit "milestones#edit"
                      :link-entities "milestones#link_entities"
                      :comments "milestones#comments"
                      :attachments "milestones#attachments"}
               :singular-name {:key "milestone.singular" :default "Milestone"}
               :plural-name {:key "milestone.plural" :default "Milestones"}
               :plural-key :milestones
               :routes {:index :practitest.frontend.milestones/index
                        :edit :practitest.frontend.milestones/edit
                        :entity-key :milestone-id}
               :db-entity "Milestone"
               :db-table-name "milestones"
               :module "Milestone"
               :form-id :milestone-main
               :has-followers? false}
   :instance {:table-id "testset2-instances-grid"
              :singular-name {:key "instance.singular" :default "Instance"}
              :plural-name {:key "instance.plural" :default "Instances"}
              :plural-key :instances
              :module "Instance"
              :db-entity "Instance"
              :db-table-name "instances"
              :form-id :instance-main
              :has-followers? false
              :edit-permissions "instances_editor"
              :delete-permissions "instances_admin"
              :urls {:edit "instances#edit"
                     :entity "instances#entity"
                     :attachments "instances#attachments"
                     :update "instances#update"}}
   :run {:table-id "run-grid"
         :singular-name {:key "run.singular" :default "Run"}
         :plural-name {:key "run.plural" :default "Runs"}
         :plural-key :qtest_runs
         :module "Run"
         :db-entity "QtestRun"
         :db-table-name "qtest_runs"
         :form-id :run-main
         :has-followers? false
         :edit-permissions "runs"
         :delete-permissions "runs_admin"
         :urls {:edit "qtest_runs#edit"
                :entity "qtest_runs#entity"
                :update "qtest_runs#update"}}
   :test-step {:db-entity "StepDesign"
               :db-table-name "step_designs"}
   :issue {:urls {:fetch-list "issues#list2"
                  :new "issues#new"
                  :create "issues#create"
                  :update "issues#update2"
                  :entity "issues#entity"
                  :index "issues#index"
                  :edit "issues#edit"
                  :delete "issues#destroy"
                  :print "issues#print"
                  :jump-to "issues#jump_to"
                  :batch-edit "issues#batch_edit"
                  :comments "issues#comments"
                  :attachments "issues#attachments"
                  :link-entities "issues#link_entities"
                  :unlink-entity "issues#delete_traceability"}
           :routes {:index :practitest.frontend.issues.index/index
                    :edit :practitest.frontend.issues/edit
                    :entity-key :issue-id}
           :singular-name {:key "issue.singular" :default "Issue"}
           :plural-name {:key "issue.plural" :default "Issues"}
           :page-title {:key "issue.grid.title" :default "Issues"}
           :linked-label "Issues"
           :db-entity "Issue"
           :db-table-name "issues"
           :plural-key :issues
           :module "Issue"
           :edit-permissions "issues_editor"
           :delete-permissions "issues_admin"
           :form-id :issue-main
           :linked-ids-key :linked_issue_ids
           :init-traceability {:milestones [] :issues [] :runs [], :ets [], :requirements [] }
           :table-id "issues-index"
           :columns-id :issue-columns
           :has-similar-items? true
           :default-columns [{:type :external_id_or_display_id
                              :field :display_id
                              :default-width 80
                              :default-show? true
                              :autofilter? true
                              :header "ID"}
                             {:type          :has_attachment_indicator
                              :field         :has_attachment_indicator
                              :autofilter?   false
                              :default-width 80
                              :header        [icons/mux-paperclip]
                              :sortable?     true}]
           :has-followers? true}})

(defn get-entity-name [entity-type name-type]
  (let [{:keys [key default]} (get-in entities-metadata [entity-type name-type])]
    (get-translation key default)))

(defn get-fetch-entity-route
  [entity-type]
  (if-let [url (get-in entities-metadata [entity-type :urls :entity])]
    url
    (js/console.warn "No fetch entity route for entity" entity-type)))

(defn entity-by-module
  "Finds the entity keyword (e.g. :test) for a given module name (e.g. \"Test\")."
  [module]
  (some (fn [[k v]]
          (when (= module (:module v)) k))
        entities-metadata))
